"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusPreference = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactToggle = _interopRequireDefault(require("react-toggle"));

var _ChannelPreferences = require("./ChannelPreferences");

var _StyledToggle = require("./StyledToggle");

function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }

function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }

var StatusPreference = function StatusPreference(_ref) {
  var value = _ref.value,
      onPreferenceChange = _ref.onPreferenceChange,
      templateId = _ref.templateId,
      routingOptions = _ref.routingOptions,
      _ref$customizeDeliver = _ref.customizeDeliveryChannel,
      customizeDeliveryChannel = _ref$customizeDeliver === void 0 ? true : _ref$customizeDeliver;

  var _useState = (0, _react.useState)(["REQUIRED", "OPTED_IN"].includes(value)),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var onToggleStatusChange = function onToggleStatusChange(event) {
    setChecked(event.target.checked);
    var toggledValue = event.target.checked ? "OPTED_IN" : "OPTED_OUT";
    onPreferenceChange({
      status: toggledValue
    });
  };

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_StyledToggle.StyledToggle, {
    checked: checked
  }, /*#__PURE__*/_react["default"].createElement("label", null, value === "REQUIRED" ? "Required" : "Opted In"), /*#__PURE__*/_react["default"].createElement(_reactToggle["default"], {
    icons: false,
    disabled: value === "REQUIRED",
    checked: checked,
    value: value,
    onChange: onToggleStatusChange
  })), checked && customizeDeliveryChannel && /*#__PURE__*/_react["default"].createElement(_ChannelPreferences.ChannelPreferences, {
    onPreferenceChange: onPreferenceChange,
    templateId: templateId,
    routingOptions: routingOptions
  }));
};

exports.StatusPreference = StatusPreference;